import {TargetPlatformReview} from './target-platform-review.model';

/**
 * Couleurs du bouton d'invitation, par plateforme : celles sous lesquelles chacune se reconnaît.
 *
 * Le répondant vient de quitter le questionnaire pour aller déposer un avis ailleurs : le bouton
 * doit lui annoncer où il va, d'où les couleurs de la plateforme plutôt que celles de l'enquête.
 * Le cas général n'en a pas : son bouton se contente d'un fond blanc et de l'encre du questionnaire.
 *
 * Elles sont posées à chaque changement de plateforme, et restent modifiables ensuite — l'enquête
 * peut vouloir s'en écarter.
 */
export const PLATFORM_REVIEW_BUTTONS: Record<TargetPlatformReview, {fontColor: string; backgroundColor: string}> = {
    [TargetPlatformReview.GOOGLE]: {fontColor: '#ffffff', backgroundColor: '#2f54eb'},
    [TargetPlatformReview.TRIPADVISOR]: {fontColor: '#ffffff', backgroundColor: '#00af87'},
    [TargetPlatformReview.TRUSTPILOT]: {fontColor: '#ffffff', backgroundColor: '#00b67a'},
    [TargetPlatformReview.OTHER]: {fontColor: '#2f54eb', backgroundColor: '#ffffff'},
};
